import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';

let currentSnackbarData = { message: "", type: "success" };

export const useSnackbar = () => {
    return (message, type = "success") => {
        currentSnackbarData = { message, type };
        window.dispatchEvent(new Event("show-snackbar"));
    };
};

export const GlobalSnackbar = () => {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({ message: "", type: "success" });

    useEffect(() => {
        const handler = () => {
            setData(currentSnackbarData);
            setOpen(true);
        };
        window.addEventListener("show-snackbar", handler);
        return () => window.removeEventListener("show-snackbar", handler);
    }, []);

    const handleClose = () => setOpen(false);

    return (
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
            <Alert onClose={handleClose} severity={data.type} sx={{ width: "100%" }}>
                {data.message}
            </Alert>
        </Snackbar>
    );
};
